import { components } from 'react-select';

const CountriesMenuListTemplate = (props) => (
  <components.MenuList {...props}>
    {props.children}
  </components.MenuList>
);
export default CountriesMenuListTemplate;
